import React from 'react';
import PropTypes from 'prop-types';
import SearchResultBarContent from './SearchResultBarContent';
import {createFragmentContainer, graphql} from 'react-relay';

class SearchResultBar extends React.Component {

  static propTypes = {
    viewer: PropTypes.shape({
      searchModel: PropTypes.shape({
        count: PropTypes.number,
      }),
      searchItem: PropTypes.shape({
        count: PropTypes.number,
      }),
      searchCatalog: PropTypes.shape({
        count: PropTypes.number,
      })
    }),
  };

  constructor(props) {
    super(props);

    this.state = {
      margin: undefined,
    }
  }

  handleOverflowChange(isOverflowed) {
    if (isOverflowed) {
      this.setState({
        margin: '0 -14px',
      })
    } else {
      this.setState({
        margin: undefined,
      })
    }
  }

  render() {

    return (
      <div style={{position: 'relative'}}>
        <div style={{position: 'absolute', top: '0', left: '0', opacity: '0', width: '100%', zIndex: '-1'}}>
          <SearchResultBarContent viewer={this.props.viewer} onOverflowChange={::this.handleOverflowChange} />
        </div>
        <SearchResultBarContent viewer={this.props.viewer} margin={this.state.margin} />
      </div>
    )
  }

}

export default createFragmentContainer(SearchResultBar, {
  viewer: graphql`
      fragment SearchResultBar_viewer on Viewer @argumentDefinitions(
          params: {type: "String"},
      ) {
          ...SearchResultBarContent_viewer @arguments(params: $params)
      }
  `});
